import { WebData, WebDataSteps, unwrap } from "@lvt/web-data";
import { Box, Modal, CircularProgress, Typography, IconButton, Button } from "@material-ui/core";
import { Close, GetApp } from "@material-ui/icons";
import { saveAs } from "file-saver";
import { DateTime } from "luxon";

import { useStyles } from "./SnapshotModalStyles";


interface SnapshotModalProps {
    image: WebData<string>;
    handleVisible: (arg: boolean) => void;
    visible: boolean;
}

function SnapshotModal(props: SnapshotModalProps) {
    const { image, handleVisible, visible } = props;

    const img = unwrap(image);
    const classes = useStyles();

    const handleClose = () => handleVisible(false);
    const handleSaveImage = () => img && saveAs(
        `data:image/jpeg;base64,${img}`,
        `snapshot-${DateTime.now().toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}.jpeg`,
    );

    return (
        <Modal className={classes.modal} onClose={handleClose} open={visible}>
            {image.type === WebDataSteps.Loading ? (
                <CircularProgress color="secondary" size={100} />
            ) : (
                <Box className={classes.content}>
                    <Box className={classes.header}>
                        <Typography>Save Image</Typography>
                        <Box>
                            <Button
                                id={"streaming_snapshot-modal_download-button"}
                                className={classes.featureButton}
                                onClick={handleSaveImage}
                                startIcon={<GetApp />}
                            >
                                Download
                            </Button>
                            <IconButton id={"streaming_snapshot-modal_close-button"} onClick={handleClose}>
                                <Close />
                            </IconButton>
                        </Box>
                    </Box>
                    {img && <img className={classes.image} src={`data:image/jpeg;base64,${img}`} alt={"Snapshot Image"} />}
                </Box>
            )}
        </Modal >
    );
}

export default SnapshotModal;
